import { render, staticRenderFns } from "./WaveLineDashboardItem.vue?vue&type=template&id=b77ec020"
import script from "./WaveLineDashboardItem.vue?vue&type=script&lang=js"
export * from "./WaveLineDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b77ec020')) {
      api.createRecord('b77ec020', component.options)
    } else {
      api.reload('b77ec020', component.options)
    }
    module.hot.accept("./WaveLineDashboardItem.vue?vue&type=template&id=b77ec020", function () {
      api.rerender('b77ec020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/WaveLineDashboardItem.vue"
export default component.exports